import React, { useEffect, useState } from 'react';
import { RiStarFill, RiStarHalfFill, RiStarLine } from 'react-icons/ri';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const ReviewsComponent = () => {
    const [reviews, setReviews] = useState([]);

    const fetchReviews = async () => {
        try {
            const response = await fetch('/.netlify/functions/googlePlaces');
            const data = await response.json();
            if (data && data.result && data.result.reviews) {
                const reviews = data.result.reviews;
                const filteredReviews = reviews.filter((review) => review.rating > 2);
                const sortedReviews = filteredReviews.sort((a, b) => b.rating - a.rating);
                const top5Reviews = sortedReviews.slice(0, 9);
                setReviews(top5Reviews);
            }
        } catch (error) {
            console.log('Error fetching reviews:', error);
        }
    };

    useEffect(() => {
        fetchReviews();
        const setMaxCardHeight = () => {
            const cardElements = document.querySelectorAll('.card-review');
            let maxCardHeight = 0;
            cardElements.forEach((card) => {
                const cardHeight = card.offsetHeight;
                if (cardHeight > maxCardHeight) {
                    maxCardHeight = cardHeight;
                }
            });
            cardElements.forEach((card) => {
                card.style.height = `${maxCardHeight}px`;
            });
        };
    
        setMaxCardHeight();
        window.addEventListener('resize', setMaxCardHeight);
    
        return () => {
            window.removeEventListener('resize', setMaxCardHeight);
        };
    }, []);

    const calculateAverageRating = () => {
        if (reviews.length === 0) return 0;

        const totalRating = reviews.reduce((sum, review) => sum + review.rating, 0);
        const averageRating = totalRating / reviews.length;
        return averageRating.toFixed(1);
    };

    const renderRatingStars = (rating) => {
        const fullStars = Math.floor(rating);
        const halfStar = rating % 1 !== 0;

        return (
            <div className="text-warning">
                {[...Array(fullStars)].map((_, index) => (
                    <RiStarFill key={index} className="star-icon" />
                ))}
                {halfStar && <RiStarHalfFill className="star-icon" />}
                {[...Array(5 - Math.ceil(rating))].map((_, index) => (
                    <RiStarLine key={index} className="star-icon" />
                ))}
            </div>
        );
    };

    return (
        <div className="container">
            <div className="text-center mt-4 text-white bold-text">
                <h4>Dicono di noi</h4>
                <div className="align-items-center mb-3">
                    <h4 className="me-2">{renderRatingStars(parseFloat(calculateAverageRating()))} {calculateAverageRating()}</h4>
                    <p className="mt-3">Le nostre migliori 5 recensioni su Google!</p>
                </div>
            </div>
            <div className="row">
                {reviews.length > 0 ? (
                    <Carousel showArrows={true} infiniteLoop={true} autoPlay={true} interval={5000} showStatus={false} showThumbs={false}>
                        {reviews.map((review) => (
                            <div key={review.author_name} className="col-12 mb-5">
                                <div className="card mb-4">
                                    {review.profile_photo_url && (
                                        <div className='pt-2 r'>
                                            <img
                                                src={review.profile_photo_url}
                                                alt={review.author_name}
                                                className="card-img-top rounded-circle img-thumbnail"
                                                style={{ width: '80px', height: '80px' }}
                                            />
                                        </div>
                                    )}
                                    <div className="card-body text-center">
                                        <h5>{renderRatingStars(review.rating)}</h5>
                                        <h5>{review.author_name}</h5>
                                        <p className="card-text">{review.text}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Carousel>
                ) : (
                    <div className="col-12">
                        <p>Nessuna recensione disponibile</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ReviewsComponent;